import { LineChartOutlined } from '@ant-design/icons';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import styles from '../OperationsDashboard/ops-theme.module.css';

const OpsTrendsTab: FC = () => {
  const { t } = useTranslation('dashboard.OperationsDashboard');

  return (
    <div className={`${styles.placeholderTab} ${styles.animFadeUp}`}>
      <div className={styles.placeholderIcon}>
        <LineChartOutlined />
      </div>
      <div className={styles.placeholderTitle}>{t('tabTrends')}</div>
      <div className={styles.placeholderDescription}>
        {t('placeholderDescription')}
      </div>
    </div>
  );
};

export default OpsTrendsTab;
